import { useState } from 'react'

import {
  DomainsForTableDTO,
  QueryProps,
  QueryVariables,
} from 'features/inventory/domain/components/DomainsTable/types/api'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { DomainsForTable } from '../..'
import { domainsFromDTO, sortToDTO } from './mapper'
import { GET_DOMAINS_FOR_TABLE } from './query'
import { Data, UseGetDomains } from './types'

export const useGetDomains = ({ filters, first, last, sort }: QueryProps): UseGetDomains => {
  const { workspaceId } = useWorkspaceParam()
  const [domains, setDomains] = useState<DomainsForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<QueryVariables, Data>({
    onCompleted: async (data: Data) => {
      const {
        domains: { nodes: domains, totalCount: count },
      } = data

      if (domains) {
        setDomains(
          domains.map((domain: DomainsForTableDTO): DomainsForTable => domainsFromDTO(domain)),
        )
        setCount(count)
      }
    },
    query: GET_DOMAINS_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { count, domains, loading }
}
